import * as React from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  TextField,
  FormHelperText,
} from "@mui/material";
import { createnewPermision, createnewTag } from "../../DAL/create";
import { updatePermision, updateTag } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
};

export default function AddTag({ open, setOpen, Modeltype, Modeldata }) {
  const [name, setName] = React.useState(Modeldata?.tagName || "");
  const [order, setOrder] = React.useState(Modeldata?.sortOrder || ""); // New state
  const [id, setId] = React.useState(Modeldata?.id || "");
  const [error, setError] = React.useState("");
  const [type, setType] = React.useState(false);
  const [image, setImage] = React.useState("");
  const [previewImage, setPreviewImage] = React.useState("");

  const isFormValid = name?.trim() && Number(order) > 0 && previewImage;

  React.useEffect(() => {
    setName(Modeldata?.tagName || "");
    setOrder(Modeldata?.sortOrder || "");
    setId(Modeldata?.id || "");
  }, [Modeldata]);

  const handleClose = () => {
    setOpen(false);
    setName("");
    setOrder("");
    setPreviewImage("");
  };

  const handleImageUpload = (e) => {
    const value = e.target.files[0];
    setImage(value);
    setPreviewImage(URL.createObjectURL(value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) {
      setType(true);
      return;
    }
    if (!order) {
      setType(true);
      return;
    }
    try {
      if (Modeltype === "Add") {
        const response = await createnewTag({
          tagName: name,
          sortOrder: order,
          file: image,
        });
        if (response?.data?.statusCode == 201) {
          setOpen(false);
          enqueueSnackbar(response?.data?.message, { variant: "success" });
        } else if (response?.status == 400) {
          enqueueSnackbar(response?.error, { variant: "error" });
        } else if (response?.statusCode == 409) {
          enqueueSnackbar(response?.message, { variant: "error" });
        } else {
          enqueueSnackbar(response?.message, { variant: "error" });
        }
      } else {
        const formData = new FormData();
        formData.append("tagName", name);
        formData.append("sortOrder", order);
        if (image) formData.append("file", image);

        const response = await updateTag(id, formData);
        if (response?.data?.statusCode == 200) {
          setOpen(false);
          enqueueSnackbar(response?.data?.message, { variant: "success" });
        } else if (response?.status == 400) {
          enqueueSnackbar(response?.error, { variant: "error" });
        } else if (response?.statusCode == 409) {
          enqueueSnackbar(response?.message, { variant: "error" });
        } else {
          enqueueSnackbar(response?.message, { variant: "error" });
        }
      }
      // setOpen(false);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      BackdropProps={{
        sx: {
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Box sx={style}>
        <Typography id="modal-title" variant="h6" component="h2">
          {Modeltype} Live Stream Tag
        </Typography>
        <TextField
          sx={{ marginTop: "10px", borderRadius: "6px" }}
          fullWidth
          required
          label="Tag Name"
          variant="outlined"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          inputProps={{ maxLength: 20 }}
        />
        {type == true && !name && (
          <FormHelperText sx={{ color: "red" }}>
            {"Tag name field is required"}
          </FormHelperText>
        )}
        <TextField
          sx={{ marginTop: "10px", borderRadius: "6px" }}
          fullWidth
          required
          label="Sort Order"
          variant="outlined"
          name="order"
          type="number"
          value={order}
          onChange={(e) => setOrder(e.target.value < 0 ? 0 : e.target.value)}
          inputProps={{ min: 1, max: 5000 }}
        />
        {type == true && !order && (
          <FormHelperText sx={{ color: "red" }}>
            {"Sort order field is required"}
          </FormHelperText>
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 3,
          }}
        >
          <div>
            <Typography>Upload Image *</Typography>
            <FormHelperText>Supported Formats (JPG,JPEG,PNG)</FormHelperText>
          </div>
          <div>
            {previewImage && (
              <img
                src={previewImage}
                alt=""
                style={{ width: "150px", height: "60px" }}
              />
            )}
          </div>
          {type == true && !previewImage && (
            <FormHelperText sx={{ color: "red" }}>
              {"Sort order field is required"}
            </FormHelperText>
          )}
          <div>
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="upload-button"
              type="file"
              name="image"
              onChange={handleImageUpload}
            />
            <label htmlFor="upload-button">
              <Button
                variant="contained"
                component="span"
                className="gradientButton"
              >
                Upload
              </Button>
            </label>
          </div>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <Button
            type="button"
            variant="contained"
            sx={{ backgroundColor: "#B1B1B1", textTransform: "none" }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            type="submit"
            variant="contained"
            className={isFormValid ? "gradientButton" : ""}
            sx={{ textTransform: "none" }}
            disabled={!isFormValid}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
